import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CardMedia } from '@mui/material';
import CardContainer from '../../utils/CardContainer';
import ReadMoreText from '../../utils/ReadMore';
import { MovingText } from '../../utils/MovingText';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { CutCurrency } from '../../utils/CutCurrency';
import { ImagePath, ImageRelativePath, Website_Url } from '../../constants';
import useAuthStore from '../../../store/useAuthStore';


export const PriceSection = ({ price, start_date, end_date, isdicount, originalPrice, start_time, end_time }) => {
    return (
        <>
            <Box sx={{ display: 'flex', gap: "20px", my: 0.5 }}>
                <Typography variant='body2'>Start Date : {start_date} </Typography>
                <Typography variant='body2'>End Date: {end_date} </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: "20px", my: 0.5 }}>
                <Typography variant='body2'>{start_time ? `Start Time : ${start_time}` : ""}</Typography>
                <Typography variant='body2'>{end_time ? `End Time : ${end_time}` : ""}</Typography>
            </Box>
            <Typography variant='body2' sx={{ display: 'flex', alignItems: 'center' }}>
                Price :
                {isdicount ? (
                    <CutCurrency
                        fontSize={"15px"}
                        iconSize={"15px"}
                        value={originalPrice}
                    />
                ) : null}
                <Typography
                    variant='h5'
                    color='success.main'
                    component="span"
                    sx={{ display: 'flex', alignItems: 'center', ml: 1 }} // Added 
                >
                    <CurrencyRupeeIcon fontSize="" />
                    {price}
                </Typography>
            </Typography>
        </>
    )
}

const PurchasedCourseCard = ({ item }) => {
    const { user } = useAuthStore()
    const { slug, type } = item
    const url = type === 6 ? `${Website_Url}OnlineCourseDetail/${slug}` : `${Website_Url}CoursesDetail/${slug}`;
    const handlePushchased = () => {
        window.location.href = url

    }
    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${item?.cover_image}`}

                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>
                    <MovingText variant={"h5"} text={item?.title} width={"100%"} />
                    <ReadMoreText text={item?.short_description} />
                    {/* <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }} my={0.5}>
                        <Icon icon="weui:location-outlined" width="15" />
                        {item?.location_name}
                    </Typography> */}
                    {/* {
                        isopen && <>
                            <Box sx={{ display: 'flex', gap: "20px" }}>
                                <Typography variant='body2'>From : {item?.start_date}</Typography>
                                <Typography variant='body2'>To : {item?.end_date}</Typography>
                            </Box>
                            <Typography variant='body2' mb={1} display={"flex"} alignItems={"center"}>Price : <CurrencyRupeeIcon fontSize='10px' />{item?.price}</Typography>
                        </>
                    } */}

                    <Button variant='contained' fullWidth onClick={handlePushchased}>Purchase Your Course</Button>
                </CardContent>
            </CardContainer>

        </>
    )
}

export default PurchasedCourseCard